import { render, staticRenderFns } from "./ad.vue?vue&type=template&id=7a34e6a9"
import script from "./ad.vue?vue&type=script&lang=js"
export * from "./ad.vue?vue&type=script&lang=js"
import style0 from "./ad.vue?vue&type=style&index=0&id=7a34e6a9&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a34e6a9')) {
      api.createRecord('7a34e6a9', component.options)
    } else {
      api.reload('7a34e6a9', component.options)
    }
    module.hot.accept("./ad.vue?vue&type=template&id=7a34e6a9", function () {
      api.rerender('7a34e6a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/ad.vue"
export default component.exports